import API from '../api';

export const getInterviewTypes = ({
  params: { page, uuid, page_size } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/interviews/interview_types/`, {
        params: { page, page_size },
        signal,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postInterviewType = ({ name, description, code } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post('/interviews/interview_types/', { name, description, code })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const patchInterviewType = (uuid, { name, description, code } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/interviews/interview_types/${uuid}/`, {
        name,
        description,
        code,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const deleteInterviewType = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      API.delete(`/interviews/interview_types/${uuid}/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
